import { render, staticRenderFns } from "./cloud-disk.vue?vue&type=template&id=8fc80daa&scoped=true&"
import script from "./cloud-disk.vue?vue&type=script&lang=js&"
export * from "./cloud-disk.vue?vue&type=script&lang=js&"
import style0 from "./cloud-disk.vue?vue&type=style&index=0&id=8fc80daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc80daa",
  null
  
)

export default component.exports